import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/dist/style.css';
import { PhoneInputWrapper } from './elements';

/**
 * Phone Number Input Styles
 **/

export function PhoneNumber({
  defaultCountry,
  number,
  onChange,
  onlyCountries,
  preferredCountries,
  inputExtraProps,
  countryCodeEditable
}) {
  return (
    <PhoneInputWrapper>
      <PhoneInput
        name="phoneInput"
        defaultCountry={defaultCountry}
        value={number}
        onChange={onChange}
        autoFormat={true}
        required={true}
        placeholder="+254798984828"
        preferredCountries={
          preferredCountries && preferredCountries.length
            ? preferredCountries
            : ['ke', 'ug', 'rw']
        }
        disableAreaCodes={true}
        countryCodeEditable={countryCodeEditable}
        onlyCountries={onlyCountries}
        enableSearchField={onlyCountries ? false : true}
        disableSearchIcon={true}
        inputExtraProps={inputExtraProps}
      />
    </PhoneInputWrapper>
  );
}

export default PhoneNumber;
